import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const Footer = () => {
    const date = new Date();
    const year = date.getFullYear();
    return (_jsxs("footer", { className: "flex flex-col md:flex-row mx-5 my-2 text-sm ", "data-test": "cat-footer", children: [_jsxs("div", { className: "flex-1", children: [_jsxs("a", { className: "ot-sdk-show-settings hover:underline cursor-pointer", "data-test": "cookie-settings", children: [" ", "Cookie Settings"] }), _jsx("span", { "data-test": "cat-confidential-yellow", children: " | Cat Confidential: Yellow" })] }), _jsxs("div", { "data-test": "cat-all-rights-reserved", children: ["Caterpillar \u00A9 ", year, " All Rights Reserved"] })] }));
};
export default Footer;
